import TextField from '@mui/material/TextField';

const FromTextField =  ({
  label = "物件番号",
  helperText = "",
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfBukkenNo"
    label={label}
    size="small"
    inputProps={{ maxLength: 15 , pattern: "^[a-zA-Z0-9_]+$"}}
    onChange={(event: any) => { onChange(event); }}
    error={!!helperText}
    helperText={helperText}
  />
);

export default FromTextField;